module.exports = __webpack_public_path__ + "img/flamearrestor.c2d74595.jpg";